import React, {Fragment, useEffect, useState} from "react";
import {connect} from 'react-redux'
import 'bootstrap/dist/css/bootstrap.min.css';
import {Form, Row, Dropdown, FormLabel, FormGroup} from 'react-bootstrap'
import {getOPKSFilters} from '../../../actions/FilterActions'
import Select from "react-select";
import {CardBody} from "reactstrap";
import {refreshFilters, setPreviousFilter} from "../../../actions";


const OPKFilter = ({Filters:{opk_filters,available_filters,previous_filter},PlotData:{active_plot},setPreviousFilter,refreshFilters,getAll}) => {
    const [opkSelect,setOpkSelect] =useState('')
    useEffect(() => {
        if(previous_filter.hasOwnProperty(active_plot)){
            if(previous_filter[active_plot].hasOwnProperty(getOpkFilterID())){
                if(previous_filter[active_plot][getOpkFilterID()]==="none"){
                    setOpkSelect('')
                }
                else{
                    setOpkSelect(getOpkValues(previous_filter[active_plot][getOpkFilterID()]))
                }
            }
            else
            {
                setOpkSelect('')
            }

        }
        else{
            setOpkSelect('')
        }

    },[active_plot])
    const getValues=()=>{
        if(Array.isArray(opk_filters) && opk_filters.length>0){

            const options =  opk_filters.map(opk=>{return {"label":opk.number + " " + opk.name,"value":opk.number}})
            return options
        }
        else{
            return {label:"Brak dostępnych opk","value":""}
}    };

    const getOpkValues=(opk)=>{
        try{
           let opk_list=getValues();


           opk_list = opk_list.filter(x=>x.value===opk)[0]
           return opk_list
        }
        catch(e){
            console.log(e)
        }

    }
     const getOpkFilterID=()=>{
          if (available_filters.length !== 0) {
            let active_filters_exist = available_filters.filter(x => x.pola === "opk_select");
            if (active_filters_exist.length !== 0) {
                return  active_filters_exist[0].id
            }
        }
    };
    return (<Fragment>
             <Select
                className="react-select nowaOkr"
                classNamePrefix="react-select select-wskazniki"
                name="opkSelect"
                value={opkSelect}
                onChange={(value) => {
                    setOpkSelect(value);
                    console.log({[active_plot]: getOpkFilterID()}, value.value)
                    setPreviousFilter({[active_plot]: getOpkFilterID()}, value.value);
                    refreshFilters()
                }}
                options={getValues()}
                placeholder={(Array.isArray(opk_filters) && opk_filters.length>0) ?"Wybierz OPK" : "Brak dostępnych opk"}
            />
            </Fragment>
    )


};

const mapStateToProps = state => ({
    Filters: state.Filters,
    PlotData: state.PlotData,


});
export default connect(mapStateToProps, {setPreviousFilter,refreshFilters})(OPKFilter)

